/* eslint-disable max-len */

import * as R from 'ramda';
import moment from 'moment';

export default function ReleaseProductsController(
  $location,
  $q,
  $scope,
  alerts,
  loaderService,
  orgDataService
) {
  const vm = this;

  vm.groupId = 58;

  vm.appIsLoaded = false;

  vm.showFilters = true;

  vm.minDate = new moment('20220101', 'YYYYMMDD');
  vm.maxDate = new moment();

  vm.now = new moment();
  vm.ninetyDaysAgo = new moment().subtract(90, 'd');

  vm.filter = {
    searchText: '',
    productId: 'all',
    typeId: 'all',
    minDate: vm.minDate,
    maxDate: vm.maxDate,
    startDate: vm.ninetyDaysAgo.clone(),
    endDate: vm.now.clone(),
    customerHasProduct: true,
    customerDoesNotHaveProduct: true,
  };

  vm.services = [];
  vm.itemTypes = [];

  vm.releaseNoteProducts = null;
  vm.filteredReleaseNotes = null;

  vm.orderBy = 'productName';

  vm.handleFilterChange = handleFilterChange;
  vm.handleClearFilters = handleClearFilters;
  vm.handleToggleShowFilters = handleToggleShowFilters;
  vm.handleSort = handleSort;

  _activate();

  function _activate() {
    _initEventListeners();

    _refreshReleaseNoteList().then(() => {
      vm.appIsLoaded = true;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshReleaseNotes', _refreshReleaseNoteList);
    $scope.$on('handleUserFilterChange', handleFilterChange);
  }

  function handleFilterChange() {
    let _releaseNoteProducts = null;

    if ((vm.filter.searchText === undefined || vm.filter.searchText === '') && vm.filter.productId === 'all'
      && vm.filter.typeId === 'all' && vm.filter.startDate === vm.ninetyDaysAgo && vm.filter.endDate === vm.now
      && vm.filter.customerHasProduct === true && vm.filter.customerDoesNotHaveProduct === true) {
      vm.filteredReleaseNotes = vm.releaseNoteProducts;
      return;
    }

    _releaseNoteProducts = angular.copy(vm.releaseNoteProducts);

    // Customer Has Product
    if ((vm.filter.customerHasProduct) && (!vm.filter.customerDoesNotHaveProduct)) {
      _releaseNoteProducts = R.filter(R.propEq('customerHasProduct', true))(_releaseNoteProducts);
    }

    if ((!vm.filter.customerHasProduct) && (vm.filter.customerDoesNotHaveProduct)) {
      _releaseNoteProducts = R.filter(R.propEq('customerHasProduct', false))(_releaseNoteProducts);
    }

    if ((!vm.filter.customerHasProduct) && (!vm.filter.customerDoesNotHaveProduct)) {
      vm.filteredReleaseNotes = [];
      return;
    }

    // Product
    if ((vm.filter.productId !== undefined) && (vm.filter.productId !== 'all')) {
      _releaseNoteProducts = R.filter(R.propEq('productName', vm.filter.productId))(_releaseNoteProducts);
    }

    // Search Text
    if (vm.filter.searchText !== undefined && vm.filter.searchText !== '') {
      R.forEach((releaseNoteProduct) => {
        const stg = R.defaultTo('');
        const searchFilter = item => R.contains(vm.filter.searchText.toLowerCase(), stg(item.title).toLowerCase())
          || R.contains(vm.filter.searchText.toLowerCase(), stg(item.itemDescription).toLowerCase())
          || R.contains(vm.filter.searchText.toLowerCase(), stg(item.itemName).toLowerCase());
        releaseNoteProduct.releaseNoteItems = R.filter(searchFilter, releaseNoteProduct.releaseNoteItems);
      }, _releaseNoteProducts);
    }

    // Type
    if ((vm.filter.typeId !== undefined) && (vm.filter.typeId !== 'all')) {
      R.forEach((releaseNoteProduct) => {
        releaseNoteProduct.releaseNoteItems = R.filter(R.propEq('itemType', vm.filter.typeId))(releaseNoteProduct.releaseNoteItems);
      }, _releaseNoteProducts);
    }

    // Start / End Date
    if ((vm.filter.startDate !== undefined) && (vm.filter.endDate !== undefined) && (_releaseNoteProducts !== null)) {
      R.forEach((releaseNoteProduct) => {
        const _dateFilteredReleaseNoteItems = [];

        R.forEach((releaseNoteItem) => {
          if ((releaseNoteItem.releaseDate !== null) && (releaseNoteItem.releaseDate !== undefined)
            && (releaseNoteItem.releaseDate.fullDate !== undefined) && (releaseNoteItem.releaseDate.fullDate !== null)) {
            const fullDate = new Date(releaseNoteItem.releaseDate.fullDate);
            if ((fullDate >= vm.filter.startDate) && (fullDate <= vm.filter.endDate)) {
              _dateFilteredReleaseNoteItems.push(releaseNoteItem);
            }
          }
        }, releaseNoteProduct.releaseNoteItems);

        releaseNoteProduct.releaseNoteItems = _dateFilteredReleaseNoteItems;
      }, _releaseNoteProducts);
    }

    // Remove Release Note Products where there are no remaining release notes
    const _filteredReleaseNoteProducts = [];

    if (_releaseNoteProducts !== null) {
      R.forEach((releaseNoteProduct) => {
        if ((releaseNoteProduct.releaseNoteItems !== null) && (releaseNoteProduct.releaseNoteItems !== undefined)
          && (releaseNoteProduct.releaseNoteItems.length > 0)) {
          _filteredReleaseNoteProducts.push(releaseNoteProduct);
        }
      }, _releaseNoteProducts);
    }

    vm.filteredReleaseNotes = _filteredReleaseNoteProducts;
  }

  function handleClearFilters() {
    vm.filter.searchText = '';
    vm.filter.productId = undefined;
    vm.filter.typeId = undefined;
    vm.filter.startDate = vm.ninetyDaysAgo.clone();
    vm.filter.endDate = vm.now.clone();

    handleFilterChange();
  }

  function handleToggleShowFilters() {
    vm.showFilters = !vm.showFilters;
  }

  function handleSort(propertyName) {
    if (vm.orderBy === propertyName) {
      if (propertyName.startsWith('-')) {
        propertyName = propertyName.substring(1);
      } else {
        propertyName = `-${propertyName}`;
      }
    }
    vm.orderBy = propertyName;
  }

  function _refreshReleaseNoteList() {
    return _refreshReleaseNotes(false);
  }

  function _refreshReleaseNotes(clearFilters) {
    const dfdRefresh = $q.defer();

    if (clearFilters) {
      handleClearFilters(false);
    }

    loaderService.showViewLoader = true;
    orgDataService.getReleaseNoteItems().then((response) => {
      vm.releaseNoteProducts = response.data.result;

      _populateFilterParameters();

      handleFilterChange();
      loaderService.showViewLoader = false;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _populateFilterParameters() {
    R.forEach((releaseNoteProduct) => {
      R.forEach((releaseNoteItem) => {
        if ((releaseNoteItem.products !== null) && (releaseNoteItem.products !== undefined)
          && (releaseNoteItem.products.length > 0)) {
          R.forEach((product) => {
            let isFound = false;
            const serviceName = product;
            if (vm.services && vm.services.length > 0) {
              isFound = R.find(R.propEq('name', serviceName), vm.services);
            }
            if (!isFound) {
              vm.services.push({
                value: serviceName,
                name: serviceName
              });
            }
          }, releaseNoteItem.products);
        }

        if ((releaseNoteItem.itemType !== null) && (releaseNoteItem.itemType !== undefined)
          && (releaseNoteItem.itemType !== '')) {
          let isFound = false;
          const itemType = releaseNoteItem.itemType;
          if (vm.itemTypes && vm.itemTypes.length > 0) {
            isFound = R.find(R.propEq('name', itemType), vm.itemTypes);
          }
          if (!isFound) {
            vm.itemTypes.push({
              value: itemType,
              name: itemType
            });
          }
        }
      }, releaseNoteProduct.releaseNoteItems);
    }, vm.releaseNoteProducts);
  }
}

ReleaseProductsController.$inject = [
  '$location',
  '$q',
  '$scope',
  'alerts',
  'loaderService',
  'orgDataService'
];
